import pushTokenService from '../services/pushToken.service';
import { readAppRelease } from './appRelease';

export const NATIVE_PUSH_QUERY = 'zfcm';
export const NATIVE_PUSH_STORAGE_KEY = 'zeedcom_native_fcm';
export const NATIVE_PUSH_DEVICE_ID = 'native-android';

export const takeNativeTokenFromSearch = (search: string): {
  token: string | null;
  nextSearch: string;
} => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const token = params.get(NATIVE_PUSH_QUERY);
  if (!token || token.length < 50) {
    return { token: null, nextSearch: search };
  }
  params.delete(NATIVE_PUSH_QUERY);
  const remaining = params.toString();
  return {
    token,
    nextSearch: remaining ? `?${remaining}` : ''
  };
};

export const persistNativePushToken = (token: string) => {
  try {
    sessionStorage.setItem(NATIVE_PUSH_STORAGE_KEY, token);
    localStorage.setItem(NATIVE_PUSH_STORAGE_KEY, token);
  } catch {
    // Private mode can block storage.
  }
};

export const readNativePushToken = (): string | null => {
  try {
    return sessionStorage.getItem(NATIVE_PUSH_STORAGE_KEY)
      || localStorage.getItem(NATIVE_PUSH_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const captureNativePushTokenFromLocation = (): string | null => {
  if (typeof window === 'undefined') return null;
  const taken = takeNativeTokenFromSearch(window.location.search);
  if (taken.token) {
    persistNativePushToken(taken.token);
    const next = `${window.location.pathname}${taken.nextSearch}${window.location.hash}`;
    window.history.replaceState(null, '', next);
    return taken.token;
  }
  return readNativePushToken();
};

export const registerNativePushToken = async (): Promise<boolean> => {
  const token = readNativePushToken();
  if (!token) return false;
  await pushTokenService.registerToken({
    token,
    deviceType: 'android',
    deviceId: NATIVE_PUSH_DEVICE_ID,
    appVersion: readAppRelease().name
  });
  return true;
};
